import toggle from '@/js/util/symbols/toggle'

export default {
  provide() {
    return {
      [toggle]: this,
    }
  },
  props: {
    tag: {
      type: String,
      default: 'div',
    },
  },
  data() {
    return {
      buttons: [],
      currentButton: undefined,
    }
  },
  computed: {
    currentButtonIndex() {
      const { currentButton } = this
      if (!currentButton) {
        return undefined
      }

      return this.buttons.indexOf(currentButton)
    },
    evaluatesMenu() {
      return this.currentButtonIndex === 1
    },
    evaluatesSearch() {
      return this.currentButtonIndex === 0
    },
  },
  created() {
    this.$on('set:current', this.setCurrentButton)
    this.$on('create:buttons', this.createButtons)
  },
  methods: {
    createButtons(button) {
      this.buttons.push(button)
    },
    setCurrentButton(button) {
      this.currentButton = button !== this.currentButton ? button : undefined
    },
  },
  render(createNode) {
    return createNode(this.tag, this.$scopedSlots.default({
      evaluatesMenu: this.evaluatesMenu,
      evaluatesSearch: this.evaluatesSearch,
    }))
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseToggle.js